import script from "./SortAndSections.vue?vue&type=script&setup=true&lang=js"
export * from "./SortAndSections.vue?vue&type=script&setup=true&lang=js"

import "./SortAndSections.vue?vue&type=style&index=0&id=10bc20ed&lang=scss"

const __exports__ = script;

export default __exports__